import * as React from 'react'

import { OptionsSubpage } from '../types'
import { OptionsParsedQuery } from '../utils/query'

export function useOptionsSortOrder(subpage: OptionsSubpage, query: OptionsParsedQuery, defaultOrder: string) {
  return React.useMemo(() => {
    if (query.order[subpage]) {
      return query.order[subpage]
    }
    return defaultOrder
  }, [defaultOrder, query, subpage])
}
